/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1ProfileVersionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PROFILE_VERSION_EVENT_ENTITY_NAME = 'ixc.registration.v1.ProfileVersionEvent';
export const ixcRegistrationV1ProfileVersionEventEntity = new schema.Entity<IxcRegistrationV1ProfileVersionEvent>(IXC_REGISTRATION_V1_PROFILE_VERSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcRegistrationV1ProfileVersionEvent) => `${entity.metadata?.eventId}` });

